import "./styles.css";
import { mount } from "./app.js";

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app root element missing");
}

mount(root);
